<i18n>
{
  "ru":{
    "answer_code": "Код ответа",
    "payment_type": "Тип платежа",
    "browser_data": "Данные браузера",
    "system_fee": "Системная комиссия",
    "system": "Системная операция",
    "cc": "Карта",
    "cc_copy": "Карта",
    "field_payer_email": "Email плательщика",
    "transaction_log": "Журнал операций по платежу",
    "message_transaction_actions_disabled": "Выполнение операций по рекуррентному платежу запрещено",
    "check": "Чек",
    "print_check": "Распечатать"
  },
  "en":{
    "answer_code": "Answer code",
    "payment_type": "Payment type",
    "browser_data": "Browser data",
    "system_fee": "System fee",
    "system": "System",
    "cc": "Cards",
    "cc_copy": "Cards",
    "field_payer_email": "Payer email",
    "transaction_log": "Transaction log",
    "message_transaction_actions_disabled": "Any operations were deprecated for recurrent transactions",
    "check": "Сheck",
    "print_check": "Print"
  }
}
</i18n>
<template>
  <el-row class="payment-details details line-top" v-loading="loading">
    <invoice-refund-modal
      v-if="showRefundModal"
      :visible.sync="showRefundModal"
      :payment="paymentData.tr"
      :max="paymentData.refundMaxAmt"
      :callback="afterAction"
      :url="url"
    />
    <check-language-modal
        v-if="showCheckLanguageModal"
        :visible.sync="showCheckLanguageModal"
        :pdf_check_urls="paymentData.tr.pdf_check_urls"
    />
    <el-row class="right-align" :gutter="10" tag="p">
      <el-col v-if="showButtons">
        <el-button
          v-if="showRefundButton"
          round
          type="danger"
          size="mini"
          @click.prevent="refund()"
        >{{ $t('refund') }}</el-button>
        <el-button
          v-if="showNotifyButton"
          @click="notify"
          round
          size="small"
          type="primary"
        >{{ $t('notify') }}</el-button>
        <el-button
          v-if="showVoidButton"
          round
          type="primary"
          size="mini"
          @click.prevent="voidAction()"
        >{{ $t('void') }}</el-button>
        <el-button
          v-if="showCompleteButton"
          round
          type="primary"
          size="mini"
          @click.prevent="complete()"
        >{{ $t('complete') }}</el-button>
      </el-col>

      <el-col class="pa-2" v-if="paymentData.tr && !showButtons">
        <h5>{{ $t('message_transaction_actions_disabled') }}</h5>
      </el-col>
    </el-row>

    <h5 class="content-title ma-2">{{ $t('transaction_log') }}:</h5>
    <el-row :gutter="20" class="ma-3">
      <el-table class="small old" :data="paymentItems">
        <el-table-column prop="id" label="ID">
          <template slot-scope="scope">
            <span :data-label="scope.column.label" class="responsive-column">
              {{
              scope.row.id
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="amt" :label="$t('sum')">
          <template slot-scope="scope">
            <span :data-label="scope.column.label" class="responsive-column">
              {{
              scope.row.amt
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="payment_method" :label="$t('payment_type')">
          <template slot-scope="scope">
            <span :data-label="scope.column.label" class="responsive-column">
              {{
              $t(scope.row.payment_method)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')">
          <template slot-scope="scope">
            <span :data-label="scope.column.label" class="responsive-column">
              {{
              scope.row.text_status
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="APPROVAL" label="Approval">
          <template slot-scope="scope">
            <span :data-label="scope.column.label" class="responsive-column">
              {{
              scope.row.APPROVAL
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="RC" :label="$t('answer_code')">
          <template slot-scope="scope">
            <span :data-label="scope.column.label" class="responsive-column">
              {{
              scope.row.RC
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="RRN" label="RRN" width="110">
          <template slot-scope="scope">
            <span :data-label="scope.column.label" class="responsive-column">
              {{
              scope.row.RRN
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="notes" :label="$t('notes')" width="110">
          <template slot-scope="scope">
            <span :data-label="scope.column.label" class="responsive-column">
              {{
              scope.row.notes
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-row class="ma-3">
      <el-row :gutter="20">
        <el-col :span="4" :xs="24" class="table__log-user-data-title">3D Secure:</el-col>
        <el-col :span="20" :xs="24" class="table__log-user-data-description">
          {{
          $t(common.using3ds ? 'yes' : 'no')
          }}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4" :xs="24" class="table__log-user-data-title">{{ $t('field_payer_email') }}:</el-col>
        <el-col :span="20" :xs="24" class="table__log-user-data-description">
          {{
          common.email
          }}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="4" :xs="24" class="table__log-user-data-title">{{ $t('payer') }}:</el-col>
        <el-col :span="20" :xs="24" class="table__log-user-data-description">
          {{
          common.payer
          }}
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="4" :xs="24" class="table__log-user-data-title">{{ $t('public_offer') }}:</el-col>
        <el-col :span="20" :xs="24" class="table__log-user-data-description">
          {{
          $t(common.accept_public_offer === null ? '-' : (parseInt(common.accept_public_offer) ? 'yes' : 'no'))
          }}
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="4" :xs="24" class="table__log-user-data-title">{{ $t('check') }}:</el-col>
        <el-col :span="20" :xs="24" class="table__log-user-data-description">
          <el-button
              class="check-button"
              @click.prevent="printCheck()"
              type="text"
              link
          >{{ $t('print_check') }}</el-button
          >
        </el-col>
      </el-row>
    </el-row>

    <div v-if="paymentData.tr && paymentData.tr.auth_additional_info">
      <div v-if="serverData">
        <h5 class="content-title ma-2">{{ $t('browser_data') }}:</h5>
        <el-row class="ma-3">
          <el-row :gutter="20">
            <el-col :span="6" :xs="24" class="table__log-user-data-title">IP:</el-col>
            <el-col
              :span="18"
              :xs="24"
              class="table__log-user-data-description"
            >{{ serverData.REMOTE_ADDR }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :xs="24" class="table__log-user-data-title">System language:</el-col>
            <el-col
              :span="18"
              :xs="24"
              class="table__log-user-data-description"
            >{{ common.systemLanguage }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :xs="24" class="table__log-user-data-title">Agent:</el-col>
            <el-col
              :span="18"
              :xs="24"
              class="table__log-user-data-description"
            >{{ serverData.HTTP_USER_AGENT }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :xs="24" class="table__log-user-data-title">Agent language:</el-col>
            <el-col
              :span="18"
              :xs="24"
              class="table__log-user-data-description"
            >{{ serverData.HTTP_ACCEPT_LANGUAGE }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :xs="24" class="table__log-user-data-title">Cookie:</el-col>
            <el-col
              :span="18"
              :xs="24"
              class="table__log-user-data-description"
            >{{ serverData.HTTP_COOKIE }}</el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" :xs="24" class="table__log-user-data-title">Referer:</el-col>
            <el-col :span="18" :xs="24" class="table__log-user-data-description"></el-col>
          </el-row>
        </el-row>
      </div>
      <el-row v-if="paymentData.tr && paymentData.tr.PROCESSING">
        <h5 class="content-title ma-2">PROCESSING:</h5>
        <el-row class="ma-2">
          <pre>{{ JSON.stringify(paymentData.tr.PROCESSING, null, 4) }}</pre>
        </el-row>
      </el-row>
    </div>
  </el-row>
</template>

<script>
import apiRes from '../../core/apiRes'
import paymentHelper from './paymentHelper'
import InvoiceRefundModal from '../invoices/InvoiceRefundModal'
import CheckLanguageModal from './CheckLanguageModal.vue'

export default {
  name: 'payment-details',
  data: () => ({
    loading: true,
    paymentData: {},
    showRefundModal: false,
    showCheckLanguageModal: false
  }),
  components: {
    'invoice-refund-modal': InvoiceRefundModal,
    'check-language-modal': CheckLanguageModal
  },
  props: ['visible', 'url', 'callback'],
  computed: {
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    },
    serverData() {
      return this.paymentData.tr && this.paymentData.tr.payment_method_data ? this.paymentData.tr.payment_method_data : null
    },
    paymentItems() {
      return this.paymentData.tr ? this.paymentData.child && this.paymentData.child.length ? this.paymentData.child : [this.paymentData.tr] : []
    },
    common() {
      return this.paymentData.tr ? {
        systemLanguage: this.paymentData.tr.systemLanguage,
        email: this.paymentData.tr.bemail,
        payer: this.paymentData.tr.bname,
          accept_public_offer: this.paymentData.tr_extra.accept_public_offer,
        using3ds: this.paymentData.tr.transaction_log_tds_using === '1',
        pdfCheckUrl: this.paymentData.tr.pdf_check_url
      } : {}
    },
    showButtons() {
      return !paymentHelper.disabled(this.paymentData)
    },
    showNotifyButton() {
      return paymentHelper.canNotify(this.paymentData)
    },
    showRefundButton() {
      return paymentHelper.canRefund(this.paymentData)
    },
    showVoidButton() {
      return paymentHelper.canVoid(this.paymentData)
    },
    showCompleteButton() {
      return paymentHelper.canComplete(this.paymentData)
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      apiRes.get(this.url).then((data) => {
        this.paymentData = data && data.page_vars ? data.page_vars : {}
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    notify() {
      this.loading = true
      apiRes.post(this.url, {
        tid: this.paymentData.tr.id,
        notify: 'Отправить нотификатор'
      }).then((res) => {
        if (res.page_vars) {
          if (res.page_vars.send_notify_status) {
            if (!res.page_vars.send_notify_description) res.page_vars.send_notify_description = ''
            this.$alert(
              `${res.page_vars.send_notify_status}<br/>${res.page_vars.send_notify_description}`,
              this.$t('send_notify_result'),
              { type: 'info', dangerouslyUseHTMLString: true }
            )
          }
          if (this.callback) {
            this.callback()
          }

          this.load()
        }

        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    voidAction() {
      this.loading = true
      apiRes.post(this.url, {
        tid: this.paymentData.tr.id,
        a3: 'Сбросить'
      }).then((res) => {
        if (res.page_vars) {
          this.afterAction()
        } else {
          setTimeout(() => {
            this.afterAction()
          }, 2000)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    complete() {
      this.loading = true
      apiRes.post(this.url, {
        tid: this.paymentData.tr.id,
        a4: 'Завершение'
      }).then((res) => {
        if (res.page_vars) {
          this.afterAction()
        } else {
          setTimeout(() => {
            this.afterAction()
          }, 2000)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    afterAction() {
      if (this.callback) {
        this.callback()
      }
      this.load()
    },
    refund() {
      this.showRefundModal = true
    },
    printCheck() {
      this.showCheckLanguageModal = true
    }
  }
}
</script>

<style>
.table__log-user-data {
  margin: 0 10px;
}

.check-button {
  padding: 0;
  margin: 0;
  font-size: 12px;
}

.table__log-user-data .table__log-user-data-title {
  width: 120px;
}

.table__log-user-data-title,
.table__log-user-data-description {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #606266;
  word-wrap: break-word;
}

@media only screen and (max-device-width: 823px) {
  .table__log-user-data-title {
    font-weight: 600;
  }
}
</style>
